import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConnectionState } from '../../services/network.service';
import { AgentStatusService } from '../../services/agentstatus.service';
import { TelephonyStateService } from '../../providers/telephony/telephony.state.service';
import { TelephonyProvider } from '../../providers/telephony/telephony.provider';

@Component({
    selector: 'app-user-update-notification',
    templateUrl: './user-update-notification.component.html',
    styleUrls: ['./user-update-notification.component.scss']
})
export class UserUpdateNotificationComponent implements OnDestroy {
    state: ConnectionState = {
        hasNetworkConnection: true,
        hasInternetAccess: true,
        isRequestInProgress: false
    };
    private sub: Subscription = new Subscription();
    showButton: boolean = false;
    get showBanner(): boolean {
        return this.statusSrvc.isSkillUpdatedOnCall;
    }

    constructor(private statusSrvc: AgentStatusService, private telephonyState: TelephonyStateService, private telephony: TelephonyProvider) {
        this.sub.add(this.telephony.voice.events.subscribe((event) => {
            switch (event.type) {
                case 'Call':
                    switch (event.name) {
                        case 'dispose':
                            setTimeout(() => {
                                this.showButton = true
                            }, 3000);
                            break;
                    }
                    break;
                case 'AgentUpdate':
                    switch (event.name) {
                        case 'update':
                            this.showButton = true
                            break;
                    }
                    break;
            }
        }));
    }
    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }



    refresh() {
        this.showButton = false;
        this.statusSrvc.isSkillUpdatedOnCall = false;
        localStorage.removeItem('authorizationData');
        window.location.reload();
    }
}
